import { Link } from "react-router-dom";
import { episodes } from "@/mocks/anime";

const tagColor: Record<string, string> = {
  开端: "bg-primary-100 text-primary-700",
  修行: "bg-accent-100 text-accent-700",
  校园: "bg-secondary-100 text-secondary-700",
  羁绊: "bg-accent-100 text-accent-700",
  冲突: "bg-primary-100 text-primary-700",
  转折: "bg-accent-100 text-accent-700",
  身世: "bg-secondary-100 text-secondary-700",
  高潮: "bg-primary-100 text-primary-700",
  揭示: "bg-accent-100 text-accent-700",
  低谷: "bg-secondary-100 text-secondary-700",
  回归: "bg-accent-100 text-accent-700",
  结局: "bg-primary-100 text-primary-700",
};

export default function EpisodePreview() {
  const preview = episodes.slice(0, 4);

  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-3">
          <div>
            <span className="text-sm font-medium text-primary-600">EPISODES</span>
            <h2 className="font-heading mt-1 text-2xl text-foreground-900 md:text-3xl">分集速览</h2>
          </div>
          <Link to="/episodes" className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer">
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {preview.map((ep) => (
            <Link
              to="/episodes"
              key={ep.ep}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-200 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-2xl text-primary-500">EP.{ep.ep}</span>
                <span className={`rounded-full px-2.5 py-1 text-xs ${tagColor[ep.tag] || "bg-secondary-100 text-secondary-700"}`}>
                  {ep.tag}
                </span>
              </div>
              <h3 className="mt-4 text-base font-medium text-foreground-900">{ep.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{ep.desc}</p>
              <span className="mt-4 text-sm text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                查看详情 <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}